import React, { useEffect, useState } from 'react'
import { InputStandard } from 'src/components/standard.input'
import { ModalStandard, ModalStandardContent, ModalStandardDescription, ModalStandardFooter, ModalStandardHeader, ModalStandardTitle } from 'src/components/standard.modal'
import { AspFormData } from './component.addModal'
import { useForm } from 'react-hook-form'
import { ButtonIconSquare } from 'src/components/buttons'
import { IconEdit, IconLoader, IconPlus, IconX } from '@tabler/icons-react'
import { useSubAttributeAPI } from 'src/API/rest.subattribute'
import { SelectStandard } from 'src/components/standard.select'
import { useStatesAPI } from 'src/API/rest.states'


type props = {
    pricelist: ({
        FM19_M04_StateID: string,
        FM19_ASP: string,
        stateName?: string,
        FM19_PriceID?: number;
        FM19_M14_SubAttributeID?: string;
        FM19_status: number;
        FM19_MRP: number | null;
    })[],
    show: boolean,
    setShow: (show: boolean) => void,
    setPricelist: (aspData: AspFormData[]) => any,
    readOnly?: boolean,
    styleName?: string
}

export default function AspModal(props: props) {


    const { register, handleSubmit, setValue, reset, formState: { errors }, control, watch } = useForm<{
        options: AspFormData[]
    }>({
        defaultValues: {
            options: props.pricelist
        }
    });


    const {
        states,
        isFetching
    } = useStatesAPI({
        isState: 1
    })


    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [mode, setMode] = useState<'add' | 'edit'>('add');


    const onSubmit = async (data: { options: { FM19_ASP: string; }[] }) => {
        setIsSubmitting(true);




        if (mode === 'add') {


            const submitData: (AspFormData & { stateName?: string, })[] = []
            data.options.forEach((item, index) => {
                submitData.push({
                    FM19_ASP: item.FM19_ASP,
                    FM19_M04_StateID: props.pricelist[index].FM19_M04_StateID,
                    FM19_PriceID: props.pricelist[index].FM19_PriceID,
                    FM19_M14_SubAttributeID: props.pricelist[index].FM19_M14_SubAttributeID,
                    FM19_status: props.pricelist[index].FM19_status,
                    FM19_MRP: props.pricelist[index].FM19_MRP,
                    stateName: props.pricelist[index].stateName
                })
            })
            props.setPricelist(submitData)
            props.setShow?.(false)

        } else if (mode === 'edit') {


        }
        setIsSubmitting(false);
    };

    useEffect(
        () => {
            if (props.show) {
                reset({
                    options: props.pricelist
                })
            } else {

            }

        }, [props.show]
    )

    // console.log(props.pricelist)

    return (
        <ModalStandard open={props.show} onOpenChange={props.setShow}>

            <ModalStandardContent className=' bg-white'>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ModalStandardTitle className='text-sm '>ASP for Style: <span className='font-bold  text-lg text-vstarPrimary-900 uppercase tracking-wider'>{props.styleName}</span></ModalStandardTitle>
                    <ModalStandardHeader>
                        <ModalStandardDescription>
                            <div className='py-2'>
                                {props.readOnly ? (
                                    <div className="flex flex-col gap-2">
                                        <div className="grid grid-cols-2 gap-4 border-b border-gray-200 pb-2 mb-2">
                                            <span className="font-bold text-black text-sm uppercase tracking-wider">State</span>
                                            <span className="font-bold text-black text-sm uppercase tracking-wider">ASP</span>
                                        </div>
                                        <div className="flex flex-col gap-2 max-h-[60vh] overflow-y-auto pr-2">
                                            {props.pricelist.map((item, index) => {
                                                const stateName = states?.find(s => String(s.FM04_StateID) === String(item.FM19_M04_StateID))?.FM04_StateName || item.stateName || 'Unknown State';
                                                return (
                                                    <div key={index} className="grid grid-cols-2 gap-4 py-2 border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors rounded px-2">
                                                        <span className="font-medium text-black text-md flex items-center">{stateName}</span>
                                                        <span className=" text-black text-md flex items-center">₹{item.FM19_ASP || '0'}</span>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                ) : (
                                    <div className='grid grid-cols-3 gap-2 py-2'>
                                        {
                                            props.pricelist.map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <SelectStandard
                                                        disabled
                                                        options={states?.map(state => ({
                                                            value: String(state.FM04_StateID),
                                                            label: state.FM04_StateName
                                                        })) || []}
                                                        value={String(item.FM19_M04_StateID)}
                                                    />
                                                    <InputStandard
                                                        placeholder={'ASP in %'}
                                                        type='number'
                                                        {...register(`options.${index}.FM19_ASP`, { required: !props.readOnly ? "asp is required" : false })}
                                                        error={errors.options?.[index]?.FM19_ASP?.message}
                                                        step='any'
                                                        disabled={props.readOnly}
                                                    />
                                                    {!props.readOnly && (
                                                        <InputStandard
                                                            disabled
                                                            placeholder={'ASP in ₹'}
                                                            value={sessionStorage.getItem('MRP-value') ? String(Number(sessionStorage.getItem('MRP-value')) - (Number(sessionStorage.getItem('MRP-value')) * Number(watch(`options.${index}.FM19_ASP`))) / 100) : ''}
                                                        />
                                                    )}
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>
                                )}
                            </div>
                        </ModalStandardDescription>
                    </ModalStandardHeader>
                    <ModalStandardFooter>
                        <ButtonIconSquare variant="white" icon={<IconX />} text="Close" onClick={(e) => {
                            props.setShow?.(false);
                            e?.preventDefault();
                        }} disabled={isSubmitting} />
                        {!props.readOnly && (
                            <ButtonIconSquare
                                variant="secondary"
                                icon={isSubmitting ? <IconLoader className="animate-spin" /> : mode === 'add' ? <IconPlus /> : <IconEdit />}
                                text={mode === 'add' ? 'submit' : 'Edit'} type="submit"
                                disabled={isSubmitting}
                            />
                        )}
                    </ModalStandardFooter>
                </form>
            </ModalStandardContent>
        </ModalStandard>
    )
}
